import { gql } from 'apollo-angular';

import { BaseModel, parseAttr, rProperty } from '../data-model';
import { BCountry } from '../country/country';

export class BAddress extends BaseModel {
  @rProperty() id: string;
  @rProperty() label: string;
  @rProperty() address1: string;
  @rProperty() address2: string;
  @rProperty() city: string;
  @rProperty() zipCode: string;
  @rProperty() state: string;
  @rProperty() isMain: boolean;
  @rProperty() isPreferred: boolean;
  @rProperty() isDeleted: boolean;
  @rProperty(Date) createdTs: Date;
  @rProperty(Date) editedTs: Date;
  @rProperty() importedId: string;
  @rProperty() importedSource: string;
  @rProperty(Date) importedTs: string;
  isAddressContactType?: boolean = true;

  //relations
  //editedBy
  country: BCountry;

  constructor(json: any) {
    super(json);
    this.init(json);
  }

  init(json: any) {
    this.country = parseAttr<BCountry>(json, BCountry, 'country');
    if (!json) {
      this.address1 = '';
    }
    for (var field of ['isMain', 'isPreferred', 'isDeleted']) {
      // Need to keep the true value since we can also clone the email which is already true
      this[field] = json[field] == 'TRUE' || json[field] === true ? true : false;
    }
  }

  static fromRest(json: BAddress): BAddress {
    return json && Object.assign(new BAddress({}), json);
  }

  static fromRestArray(json: any[]): BAddress[] {
    return json && json.map((v) => BAddress.fromRest(v));
  }

  get addressDescription() {
    var description = '';
    if (this.address1) description += this.address1;
    if (this.address2) description += ', ' + this.address2;
    if (this.city) description += ', ' + this.city;
    if (this.zipCode) description += ', ' + this.zipCode;
    if (this.state) description += ', ' + this.state;
    return description;
  }

  shortRepresentation(countryName?: string): string {
    countryName = countryName || (this.country && this.country.name);
    return [countryName, this.state, this.city, this.address1, this.address2, this.zipCode]
      .filter((p) => p)
      .join(', ');
  }
}

export const fragment = gql`
  fragment addressFragment on AddressNode {
    id
    label
    address1
    address2
    city
    zipCode
    state
    isMain
    isPreferred
    createdTs
    editedTs
    isDeleted
    importedId
    importedSource
    importedTs
  }
`;

export const fragmentNew = gql`
  fragment newAddressFragment on NewAddressNode {
    id
    label
    address1
    address2
    city
    zipCode
    state
    isMain
    isPreferred
    isDeleted
  }
`;

export const fragmentConnection = gql`
  fragment addressConnectionFragment on AddressNodeConnection {
    edges {
      node {
        ...addressFragment
      }
    }
  }
  ${fragment}
`;
